import React from 'react';
import TimerList from '../components/TimerList';
import ClaimTable from '../components/ClaimTable';

const AlertPage = () => {
  return (
    <div className="p-6" style={{ backgroundColor: '#C6D2ED', minHeight: '100vh' }}>
      {/* <h1 className="text-2xl font-bold mb-4">Alerts</h1> */}
      {/* <TimerList /> */}
      <ClaimTable />
    </div>
  );
};

export default AlertPage;